var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backXmh",on:{"click":_vm.GoHome}})}
var staticRenderFns = []

export { render, staticRenderFns }